export default __webpack_public_path__ + "static/media/logo.6471fed1.svg";